<template>
	<div>
		<div style="margin-top: 10px;">
			<el-button @click="openDialog('new',null)" type="primary">新增角色</el-button>
		</div>
		<div style="margin-top: 20px;">
			<el-table ref="multipleTable" 
					:data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" 
					style="width: 100%" 
					element-loading-text="数据正在加载中" 
					@selection-change="handleSelectionChange" 
					:header-cell-style="headClass" 
					:row-style="rowClass">
				<el-table-column type="selection" width="60"></el-table-column>
				<el-table-column prop="role_id" label="role_id" sortable></el-table-column>
				<el-table-column prop="role_name" label="角色名称"></el-table-column>
				<el-table-column prop="role_type" label="角色分组"></el-table-column>
				<el-table-column label="是否禁用">
					<template slot-scope="scope">
						<div>
							<span v-if="scope.row.flag">是</span>
							<span v-else>否</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
				<el-table-column label="操作">
				    <template slot-scope="scope">
				      	<button @click="openDialog('update',scope.row)">修改角色</button> <button>删除角色</button> <button @click="openDialog('getFuncList',scope.row)">修改角色功能</button>
				    </template>
				</el-table-column>
			</el-table>
			<el-pagination background
				style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[10, 50, 100, 200]"
				:page-size="pageSize" 
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
		<el-dialog title="修改角色功能列表" :visible.sync="myDialog">
			<el-tree
			   ref="tree"
			  :data="funcList"
			  show-checkbox
			  node-key="id"
			  default-expand-all="true"
			  :default-checked-keys="checkList"
			  :props="defaultProps">
			</el-tree>
			<div slot="footer" class="dialog-footer">
				<el-button @click="myDialog = false">取 消</el-button>
    			<el-button type="primary" @click="updateRoleFunc">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="title" :visible.sync="myDialog1">
			<div>
				<table>
					<tr>
						<td>角色名称</td>
						<td>
							<el-input v-model="roleName"></el-input>
						</td>
					</tr>
					<tr>
						<td>角色分组</td>
						<td>
							<el-input v-model="roleType"></el-input>
						</td>
					</tr>
					<tr>
						<td>备注</td>
						<td>
							<el-input v-model="remark"></el-input>
						</td>
					</tr>
				</table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="myDialog = false">取 消</el-button>
    			<el-button type="primary" @click="newRole" v-if="isNew">确 定</el-button>
    			<el-button type="primary" @click="updateRole" v-if="!isNew">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'roleManager',
  components: {
  },
  data() {
    return {
    	total: 0,
      	currentPage: 1,
　　  	pageSize: 10,
		multipleSelection:[],
		tableData:[],
		myDialog:false,
		funcList:[],
		checkList:[],
		rid:'',
		defaultProps:{
			label:'name',
			children:'nodes'
		},
		myDialog1:false,
		remark:"",
		roleName:"",
		roleType:"",
		title:"新增角色",
		isNew:true
    }
  },
  watch: {
  },
  mounted() {
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
  	headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
		},
    rowClass({ row, rowIndex}) {
	    if(rowIndex%2 == 0){
	    	return 'background:#F1F2F7;'
	    }else{
	    	return 'background:white;'
	    }
	    return ''
		},
  	updateTable(){
  		var thiz = this;
  		const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
    	axios.get(this.$store.getters.getApiValue+'/role/list.do')
    		.then(function (response) {
  			loading.close();
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.total = data.totalCount;
		    	thiz.tableData = data.data;
		    }else{
		    	thiz.$message.error("查询异常");
		    }
		  }).catch(function (error) {
		  	loading.close();
		    console.log(error);
		    thiz.$message.error("系统异常，请与管理员联系!");
		  });
  	},
  	openDialog(method,row){
  		if(method == "getFuncList"){
  			this.rid = row.role_id;
  			this.checkList = [];
  			var thiz = this;
	    	axios.get(this.$store.getters.getApiValue+'/role/getRightsByRid.do',{
	    		params:{
	    			rid:this.rid
	    		}
	    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.funcList = data.data;
			    	for(var i = 0;i < thiz.funcList.length;i++){
			    		thiz.funcList[i].id = "m"+thiz.funcList[i].id;
			    		if(thiz.funcList[i].nodes.length > 0){
			    			for(var j = 0;j < thiz.funcList[i].nodes.length;j++){
			    				if(thiz.funcList[i].nodes[j].checked){
			    					thiz.checkList.push(thiz.funcList[i].nodes[j].id);
			    				}
			    			}
			    		}
			    	}
			    	thiz.myDialog = true;
			    }else{
			    	thiz.$message.error("查询异常");
			    }
			  }).catch(function (error) {
			    console.log(error);
			    thiz.$message.error("系统异常，请与管理员联系!");
			  });
  		}else if(method == 'new'){
  			this.remark = "";
  			this.title = "新增角色";
  			this.roleName = "";
  			this.roleType = "";
  			this.isNew = true;
  			this.myDialog1 = true;
  		}else if(method == 'update'){
  			this.rid = row.role_id;
  			this.title = "修改角色";
  			this.remark = row.remark;
  			this.roleName = row.role_name;
  			this.roleType = row.role_type;
  			this.isNew = false;
  			this.myDialog1 = true;
  		}
  	},
  	updateRoleFunc(){
  		var mids = "";
  		var fids = "";
  		var halfCheckedList = this.$refs.tree.getHalfCheckedNodes();
  		var haveCheckedList = this.$refs.tree.getCheckedNodes();
		for(var i = 0;i < halfCheckedList.length;i++){
			mids = mids + halfCheckedList[i].id.substring(1,halfCheckedList[i].id.length) + ",";
		}
		for(var i = 0;i < haveCheckedList.length;i++){
			if(haveCheckedList[i].type == 'func'){
				fids = fids + haveCheckedList[i].id + ",";
			}else{
				mids = mids + haveCheckedList[i].id.substring(1,haveCheckedList[i].id.length) + ",";
			}
		}
		var thiz = this;
	    axios.get(this.$store.getters.getApiValue+'/role/saveRight.do',{
	    	params:{
	    		fids:fids.substring(0,fids.length-1),
	    		mids:mids.substring(0,mids.length-1),
	    		resIds:'',
	    		rid:this.rid
	    	}
	    }).then(function (response) {
			var data = response.data;
			if(data.status == "200"){
				thiz.$message.success("修改角色功能列表成功!");
			    thiz.myDialog = false;
			}else{
			    thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			console.log(error);
			thiz.$message.error("系统异常，请与管理员联系!");
		});
  	},
  	newRole(){
  		var thiz = this;
	    axios.get(this.$store.getters.getApiValue+'/role/createRole.do',{
	    	params:{
	    		remark:this.remark,
	    		roleName:this.roleName,
	    		roleType:this.roleType
	    	}
	    }).then(function (response) {
			var data = response.data;
			if(data.status == "200"){
				thiz.$message.success("新增角色成功!");
				thiz.updateTable();
			    thiz.myDialog1 = false;
			}else{
			    thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			console.log(error);
			thiz.$message.error("系统异常，请与管理员联系!");
		});
  	},
  	updateRole(){
  		var thiz = this;
	    axios.get(this.$store.getters.getApiValue+'/role/update.do',{
	    	params:{
	    		remark:this.remark,
	    		roleName:this.roleName,
	    		roleType:this.roleType,
	    		roleId:this.rid
	    	}
	    }).then(function (response) {
			var data = response.data;
			if(data.status == "200"){
				thiz.$message.success("修改角色成功!");
				thiz.updateTable();
			    thiz.myDialog1 = false;
			}else{
			    thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			console.log(error);
			thiz.$message.error("系统异常，请与管理员联系!");
		});
  	},
  	delRole(){
  		var thiz = this;
	    axios.get(this.$store.getters.getApiValue+'/role/delRole.do',{
	    	params:{
	    		rid:this.rid
	    	}
	    }).then(function (response) {
			var data = response.data;
			if(data.status == "200"){
				thiz.$message.success("删除角色成功!");
				thiz.updateTable();
			    thiz.myDialog1 = false;
			}else{
			    thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			console.log(error);
			thiz.$message.error("系统异常，请与管理员联系!");
		});
  	}
  }
}
</script>

<style>
	.el-table{
  	font-size: 12px;
  	border-bottom: 1px solid #dcd8d8;
  	color: black;
  }
  .el-table tr th{
  	border-top: 0px;
  	border-left: 0px;
  	border-right: 0px;
  }
  .el-table tr td{
  	border-bottom: 1px solid #dcd8d8;
  }
</style>